module.exports = __webpack_public_path__ + "img/icone-john-deere-connected.c838b87c.svg";